import * as React from 'react';

import styled from '@emotion/styled';

const Svg = styled.svg`
  width: 22.446px;
  height: 24px;
  margin-right: 0.5rem;
`;

const VMIcon = () => {
  return (
    <Svg xmlns="http://www.w3.org/2000/svg">
        <g fill="#4694ce">
            <path d="M6.108 2.219h10.229v2.333h2.219V1.888A1.889 1.889 0 0016.668 0H5.776A1.888 1.888 0 003.89 1.888v5.66h2.218z" />
            <path d="M20.559 5.445H10.114v2.22h6.223v4.667h2.219V7.665h1.672v10.228h-5.564v-6.67a1.889 1.889 0 00-1.888-1.886H1.888A1.889 1.889 0 000 11.223v10.891a1.89 1.89 0 001.888 1.888H12.78a1.89 1.89 0 001.884-1.89v-2h5.892a1.89 1.89 0 001.888-1.888V7.333a1.89 1.89 0 00-1.885-1.888zM7.78 13.225v5a1.89 1.89 0 001.884 1.886h2.781v1.67H2.219V11.553h10.229v6.339h-2.45v-4.667z" />
        </g>
    </Svg>
  );
};

export default VMIcon;
